export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ko",
    "resource": {
      "all_program": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["모든 캠페인"])}
    }
  })
}
